export default "__VITE_ASSET__BKZUzdtW__"